import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Landing from "./components/Landing/Landing";
import Features from "./components/Features/Features";
import ContentTypes from "./components/ContentTypes/ContentTypes";
import FAQs from "./components/FAQs/FAQs";
import Footer from "./components/Footer/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

function App() {
  return (
    <div className="app">
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Landing />
              <Features />
              <ContentTypes />
              <FAQs />
              <Footer />
            </>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <>
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
